/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/ordering-item',['require','jquery','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  //var _ = require('underscore');
  //var templates = require('core/templates');
  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var OrderingItem = Marionette.Object.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    mc: null,
    onDragStart: null,
    onDragStop: null,
    onSliderUpdate: null,
    bar: null,
    thumb: null,
    value: 0,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function($element)
    {
      this.mc = $element;
      this.bar = $element.find('[data-mc=bar]');
      this.thumb = $element.find('[data-mc=thumb]');
    },

    setup: function($params)
    {
      $params = $params || { };

      $params.onMouseDown = $params.onMouseDown || this.onMouseDown;
      $params.onMouseUp = $params.onMouseUp || this.onMouseUp;

      this.onDragStart = $params.onDragStart;
      this.onDragStop = $params.onDragStop;
      this.onSliderUpdate = $params.onSliderUpdate;

      //this.thumb.on('click', $.proxy($params.onMouseDown, this));
      /*this.thumb.draggable({
        containment: this.bar,
        cursor: 'move',
        scroll: false,
        drag: $.proxy(this.onMouseMove, this),
        disabled: true
      });*/

      Draggable.create(this.thumb, {
        bounds: this.bar,
        onDrag: this.onMouseMove,
        onDragScope: this,
        //force3D: false,
        type: 'top, left'
      });

      this.mc.addClass('disabled');
      this.enable();
    },

    onMouseDown: function($e)
    {
      var $btn = $e.currentTarget;
      if ($btn.mouseEnabled)
      {
        $(document).one('mouse_up', this.onMouseUp);
        this.thumb.on('mouse_move', this.onMouseMove);
        //var $barBounds = this.bar.getBounds(this.bar.parent);
        //this.thumb.startDrag(false, new Rectangle($barBounds.x, $barBounds.y, $barBounds.width, 0));

        if (this.onDragStart != null)
          this.onDragStart($e, this);

        this.updateSliderValue();
      }
    },

    onMouseUp: function($e)
    {
      this.thumb.off('mouse_move');
      //this.thumb.stage.removeEventListener(MouseEvent.MOUSE_UP, onMouseUp);
      this.thumb.stopDrag();

      this.updateSliderValue();

      if (this.thumb.mouseEnabled)
      {
        if (this.onDragStop != null)
          this.onDragStop($e, this);

        if (this.onSliderUpdate != null)
          this.onSliderUpdate($e, this);
      }
    },

    onMouseMove: function()
    {
      this.updateSliderValue();

      if (this.onSliderUpdate != null)
        this.onSliderUpdate();
    },

    enable: function()
    {
      Draggable.get(this.thumb).enable();//.draggable('enable');
      this.disabled = false;
    },

    disable: function($customFrame)
    {
      $customFrame = ($customFrame === undefined) ? '' : $customFrame;

      Draggable.get(this.thumb).disable();//.draggable('disable');
      this.disabled = true;
    },

    onBeforeDestroy: function()
    {
      //this.thumb.stage.removeEventListener(MouseEvent.MOUSE_UP, onMouseUp);
      //this.mc.removeEventListener(MouseEvent.MOUSE_DOWN, this.onMouseDown);

      this.mc = null;
      this.onDragStart = null;
      this.onDragStop = null;
      this.onSliderUpdate = null;
    },

    updateSliderValue: function()
    {
      this.value = 100 * (this.thumb.position().left / this.bar.width());
      //this.value = (this.thumb.position().left / this.bar.width());
    }

  /*****************************************************************************************************************///}

  });

  return OrderingItem;

});

